import React, { useState, useEffect } from 'react';
import { GiChurch } from 'react-icons/gi';
import { FaQuoteLeft } from 'react-icons/fa';
import { LuBookOpen, LuTarget } from 'react-icons/lu';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../shared/firebase';

export default function BishopOffice({ activeSection, onSelectSection }) {
  const [bishopData, setBishopData] = useState({
    name: '',
    img_url: ''
  });

  useEffect(() => {
    let isMounted = true;
    async function fetchBishop() {
      try {
        const snap = await getDocs(collection(db, 'bishop'));
        if (!snap.empty) {
          const doc = snap.docs[0].data();
          if (isMounted) {
            setBishopData({
              name: doc.name || doc.bishop_name || doc.title || '',
              img_url: doc.img_url || doc.image || doc.img || ''
            });
          }
        }
      } catch (err) {
        console.error("Error fetching bishop data:", err);
      }
    }
    fetchBishop();
    return () => { isMounted = false; };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#5F5A58] font-sans selection:bg-[#7B1E3A]/20 selection:text-[#7B1E3A] flex flex-col pb-16">

      {/* Header */}
      <section className="relative bg-gradient-to-b from-[#FAF6F2] via-[#F5EFEE] to-[#E8DDD7] pt-28 sm:pt-32 pb-16 sm:pb-20 overflow-hidden border-b border-[#E8DDD7]">
        <div className="absolute right-[5%] sm:right-[10%] top-1/2 -translate-y-1/2 pointer-events-none opacity-[0.03] select-none">
          <GiChurch className="w-64 h-64 sm:w-96 sm:h-96 text-[#7B1E3A]" />
        </div>
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 sm:px-8 lg:px-12 text-center md:text-left flex flex-col md:items-start items-center">
          <div className="w-16 h-1 bg-[#D4A64A] mb-6 rounded-full"></div>
          <h1 className="font-serif font-bold tracking-[0.03em] text-[#7B1E3A] text-[38px] sm:text-[50px] md:text-[58px] lg:text-[64px] leading-[1.05] uppercase">
            Bishop {bishopData.name}
          </h1>
          <p className="mt-4 sm:mt-5 max-w-xl text-[#7B6B66] text-[15px] sm:text-[17px] leading-[1.6] font-normal">
            Pastoral vision, leadership, and guidance from the Diocesan Bishop.
          </p>
        </div>
      </section>

      <div className="max-w-[1440px] mx-auto px-6 sm:px-8 mt-16 w-full space-y-20">

        {/* Profile Section */}
        <div className="flex flex-col md:grid md:grid-cols-12 items-center gap-12 lg:gap-16">
          <div className="md:col-span-5 w-full relative">
            <div className="rounded-[32px] overflow-hidden shadow-[0_20px_50px_rgba(123,30,58,0.12)] border-[8px] border-white aspect-[4/5] bg-[#EAE2D9]">
              <img
                src={bishopData.img_url}
                alt={bishopData.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-20 h-20 bg-[#D4A64A] text-white rounded-full flex items-center justify-center border-[6px] border-white shadow-lg">
              <GiChurch className="w-8 h-8" />
            </div>
          </div>

          <div className="md:col-span-7 w-full">
            <span className="text-[#D4A64A] font-sans font-bold text-xs sm:text-sm tracking-[0.2em] uppercase block mb-3">
              EPISCOPAL LEADERSHIP
            </span>
            <h2 className="text-[#7B1E3A] font-serif font-bold text-3xl sm:text-4xl lg:text-[42px] leading-tight mb-6">
              Rt. Rev. Dr. Royce Manoj Victor
            </h2>
            <div className="space-y-5 text-[#5F5A58] text-[16px] sm:text-[17px] leading-[1.85] font-sans">
              <p>

                Diocesan Bishop

                Rt. Rev. Dr. Royce Manoj Victor serves as the Bishop of the Church of South India Diocese of Malabar and was consecrated as the first Bishop of the Diocese on 17 May 2016. Under his episcopal leadership, the Diocese seeks to grow as a vibrant community of worship, witness and service.
              </p>
              <p>
                His ministry is characterised by a commitment to spiritual renewal, pastoral care, Christian formation, mission and compassionate engagement with society. He encourages the Church to remain firmly rooted in the Gospel while responding faithfully to the changing realities and needs of the world. His episcopal vision seeks to strengthen congregations, families and young people and to encourage the Church to be a visible witness to Christ through service, compassion, justice and hope.
              </p>
            </div>
            <div className="mt-8 flex gap-4">
              <div className="flex items-center gap-2 text-[#7B1E3A] font-medium font-sans bg-white px-4 py-2 rounded-full shadow-sm border border-[#E8DDD7]">
                <LuBookOpen className="w-4 h-4 text-[#D4A64A]" />
                <span>Theology</span>
              </div>
              <div className="flex items-center gap-2 text-[#7B1E3A] font-medium font-sans bg-white px-4 py-2 rounded-full shadow-sm border border-[#E8DDD7]">
                <LuTarget className="w-4 h-4 text-[#D4A64A]" />
                <span>Vision</span>
              </div>
            </div>
          </div>
        </div>

        {/* Pastoral Message */}
        <div className="bg-white p-8 sm:p-12 rounded-[32px] border border-[#E8DDD7] shadow-[0_10px_40px_rgba(123,30,58,0.05)] relative">
          <FaQuoteLeft className="w-12 h-12 text-[#FAF6F2] absolute top-8 left-8" />
          <div className="relative z-10 pl-4 sm:pl-12 pt-8 sm:pt-4">
            <h3 className="font-serif font-bold text-[#7B1E3A] text-2xl mb-2">New Year Oath: Walking in the Gospel</h3>
            <p className="text-[#D4A64A] font-sans font-bold uppercase tracking-wider text-sm mb-6">A Journey of Renewal</p>

            <div className="text-[#5F5A58] text-[15px] sm:text-[16px] leading-[1.85] font-sans space-y-4">
              <p>
                As we step into the year 2026, the CSI Diocese of Malabar joyfully observes this year as the Year of Renewal. God graciously calls us to awaken our faith, renew our commitment, and rediscover our mission as His people. This year invites us to a deeper spiritual awakening—both personally and communally—so that our lives may truly reflect the transforming power of the Gospel.
              </p>
              <p>
                Jesus reminds us, <strong>"Then you will know the truth, and the truth will set you free" (John 8:32)</strong>. In the light of this truth, the Year of Renewal calls us to rise from spiritual complacency, to let go of weariness and fear, and to be renewed in heart, mind, and spirit. Renewal is not merely an outward change, but an inward transformation shaped by God's Word and Spirit.
              </p>
              <p>
                True renewal begins within. As the Apostle Paul exhorts, <strong>"Be transformed by the renewing of your mind" (Romans 12:2)</strong>. When our hearts are renewed, our churches are revitalized, our families are strengthened, and our witness to the world becomes more vibrant. A renewed Church is one that listens to God's Word, lives in prayer, and courageously participates in God's mission.
              </p>

              <div className="bg-[#FAF7F2] p-6 rounded-2xl border border-[#E8DDD7] my-6">
                <p className="font-bold text-[#7B1E3A] mb-3">In this Year of Renewal, we are especially called to:</p>
                <ul className="list-disc pl-5 space-y-2 text-[#7B6B66]">
                  <li>Renew our faith through prayer, worship, and meditation on Scripture.</li>
                  <li>Revitalize our church life through active participation, unity, and faithful service.</li>
                  <li>Renew our witness in society by living out justice, compassion, peace, and hope.</li>
                </ul>
              </div>

              <p>
                Our Lord calls us in Matthew 5:16, <strong>"Let your light shine before others, that they may see your good deeds and glorify your Father in heaven."</strong> Renewal becomes meaningful when God's light shines through us, bringing life and hope to others.
              </p>
              <p>
                Let us therefore pray that in 2026: our churches may be renewed, our families strengthened, our youth empowered, and the CSI Diocese of Malabar may rise as a living test of God's renewing grace.
              </p>
              <p>
                May this Year of Renewal lead us to walk faithfully in the Gospel, to live as people transformed by God's love, and to bear joyful witness to Christ in our words and deeds.
              </p>

              <blockquote className="mt-8 italic text-[#7B6B66] border-l-4 border-[#D4A64A] pl-4">
                "But those who hope in the Lord will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint."<br />
                <span className="font-bold">— Isaiah 40:31</span>
              </blockquote>
            </div>

            <div className="mt-10 border-t border-[#F0EBE5] pt-6 flex items-center justify-between">
              <div>
                <p className="font-serif font-bold text-[#7B1E3A] text-lg">Rt. Rev. Dr. Royce Manoj Victor</p>
                <p className="text-sm text-[#7B6B66] uppercase tracking-wider font-bold mt-1">Bishop in CSI Diocese of Malabar</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center pb-8">
          <button
            onClick={() => onSelectSection('about')}
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#7B1E3A] hover:bg-[#5E132A] text-white font-sans font-bold text-sm tracking-wider uppercase rounded-full transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-1"
          >
            Return to About Diocese
          </button>
        </div>

      </div>
    </div>
  );
}
